/**
 * Money and durations on screen, from a value that carries its currency (ADR 0014).
 *
 * Moved from the portal's `apps/web-app/src/money.ts` (plan-034 VIEW-PKG), with the display language passed in: the
 * portal's `formatMoney(amount)` is `moneyText(portalLocale(), amount)`. Integer minor units all the way to the pixel —
 * never a float stored, never a symbol glued onto a bare number.
 */
import { formatMoney, formatWholeMoney } from "./format.js";
/** `€27.40`. Always two decimals. */
export function moneyText(locale, amount) {
    return formatMoney(locale, amount.currency, amount.amountMinor);
}
/** `€12` — whole units only; cents only when there are any. */
export function wholeMoneyText(locale, amount) {
    return formatWholeMoney(locale, amount.currency, amount.amountMinor);
}
/** `2:22` — the duration shape used on every conversation row in the design. */
export function formatDuration(seconds) {
    const whole = Math.max(0, Math.trunc(seconds));
    const minutes = Math.trunc(whole / 60);
    const rest = whole % 60;
    return `${String(minutes)}:${String(rest).padStart(2, "0")}`;
}
/** `30:00` — the trial counter, which is minutes and seconds of talk time remaining. */
export function formatTrialRemaining(seconds) {
    return formatDuration(seconds);
}
//# sourceMappingURL=money.js.map